import { Typography, theme } from 'antd';
import { LockOutlined } from '@ant-design/icons';
import { IconBadge } from 'components/headings';
import UpgradeToProButton from './UpgradeToProButton';

const { Title, Paragraph } = Typography;

export default function ProLockOverlay({
  locked,
  title = 'Función Pro',
  description = 'Disponible en el plan Pro de LiftLogic.',
  children,
}) {
  const { token } = theme.useToken();
  if (!locked) return children;
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 12,
        padding: 48,
        textAlign: 'center',
        background: token.colorFillQuaternary,
        borderRadius: token.borderRadiusLG,
      }}
    >
      <IconBadge icon={LockOutlined} variant="solid" size="lg" />
      <Title level={4} style={{ margin: 0 }}>
        {title}
      </Title>
      <Paragraph type="secondary" style={{ maxWidth: 420, margin: 0 }}>
        {description}
      </Paragraph>
      <UpgradeToProButton />
    </div>
  );
}
